import {
  Component,
  OnInit,
} from "@angular/core";

import {
  HttpClient,
} from "@angular/common/http";

import {
  ToastrService,
} from "ngx-toastr";

import {
  finalize,
} from "rxjs/operators";

import {
  MenuMaster_create,
  MenuMaster_update,
  MenuMaster_delete,
  MenuMaster_readAllPaginated,
  SchoolMaster_ReadAllPaginated,
  Society_ReadAllPaginated,
} from "src/app/GlobalVariable";

import {
  HospitalMaster_ReadAllPaginated,
} from "src/app/GlobalVariable/Hospital.GlobalVariable";


interface MenuItem {

  menuId: number;

  menuName: string;

  menuCode: string;

  menuDesc: string;

  displayOrder: number;

  parentMenuId: number;

  defaultChildMenuId: number;

  menuIconUrl: string;

  templatePath: string;

  isActive: number;

  isDeleted: number;

  moduleName: string;

  /*
   * ModuleId is now optional for Menu Master.
   */
  moduleId: number | null;
}


interface MenuMasterReadAllPaginatedRequestDTO {

  pageSize: number;

  pageNo: number;

  whereClause?: string | null;

  orderByClause?: string | null;
}


interface ModuleEntityItem {

  id: number;

  name: string;
}


interface MenuFormModel {

  menuId: number;

  menuName: string;

  menuCode: string;

  menuDesc: string;

  displayOrder: number;

  parentMenuId: number;

  defaultChildMenuId: number;

  menuIconUrl: string;

  templatePath: string;

  isActive: number;

  moduleName: string;

  moduleId: number | null;
}


@Component({
  selector: "app-menumaster-module",
  templateUrl: "./menumaster-module.component.html",
  styleUrls: ["./menumaster-module.component.css"],
})
export class MenumasterModuleComponent
  implements OnInit {

  // ============================================================
  // EXISTING DATA
  // ============================================================

  menus: MenuItem[] = [];

  loading: boolean = false;

  saving: boolean = false;

  showForm: boolean = false;

  searchText: string = "";

  moduleFilter: string = "";

  pageNo: number = 1;

  pageSize: number = 10;


  moduleOptions = [
    "",
    "School",
    "Hospital",
    "Society",
    "Common",
  ];


  // ============================================================
  // NEW:
  // MODULE ENTITY
  // ============================================================

  moduleEntities:
    ModuleEntityItem[] = [];

  loadingModuleEntities:
    boolean = false;


  form:
    MenuFormModel = {

    menuId: 0,

    menuName: "",

    menuCode: "",

    menuDesc: "",

    displayOrder: 1,

    parentMenuId: 0,

    defaultChildMenuId: 0,

    menuIconUrl:
      "bi bi-grid",

    templatePath: "",

    isActive: 1,

    moduleName: "",

    /*
     * Optional as requested.
     */
    moduleId: null,

  };


  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
  ) {}


  ngOnInit(): void {

    this.loadMenus();
  }


  // ============================================================
  // READ ALL PAGINATED
  // ============================================================

  loadMenus(): void {

    if (
      this.loading
    ) {

      return;
    }


    this.loading = true;


    const request:
      MenuMasterReadAllPaginatedRequestDTO = {

      pageSize: 1000,

      pageNo: 1,

      whereClause: null,

      orderByClause: null,

    };


    console.log(
      "MenuMaster ReadAllPaginated Request:",
      request,
    );


    this.http
      .post<any>(
        MenuMaster_readAllPaginated,
        request,
      )
      .pipe(
        finalize(() => {

          this.loading = false;
        }),
      )
      .subscribe({

        next: (response) => {

          console.log(
            "MenuMaster ReadAllPaginated Response:",
            response,
          );


          const records =
            this.extractArray(
              response,
            );


          console.log(
            "MenuMaster Extracted Records:",
            records,
          );


          this.menus =
            records
              .map(
                (item: any) =>
                  this.normalizeMenu(
                    item,
                  ),
              )
              .filter(
                (item) =>
                  item.isDeleted === 0,
              )
              .sort(
                (a, b) => {

                  const orderDifference =
                    Number(
                      a.displayOrder || 0,
                    )
                    -
                    Number(
                      b.displayOrder || 0,
                    );


                  if (
                    orderDifference !== 0
                  ) {

                    return orderDifference;
                  }


                  return (
                    Number(
                      a.menuId || 0,
                    )
                    -
                    Number(
                      b.menuId || 0,
                    )
                  );
                },
              );


          console.log(
            "MenuMaster Normalized List:",
            this.menus,
          );


          /*
           * If Create form is open and user has not edited
           * an existing menu, ensure Display Order follows
           * latest DB data.
           */
          if (
            this.showForm &&
            this.form.menuId === 0
          ) {

            this.form.displayOrder =
              this.getNextDisplayOrder();
          }


          this.ensurePage();
        },


        error: (error) => {

          console.error(
            "MenuMaster ReadAllPaginated Error:",
            error,
          );


          this.menus = [];


          this.showError(
            error,
            "Unable to load menus.",
          );
        },

      });
  }


  // ============================================================
  // NEW:
  // NEXT DISPLAY ORDER
  //
  // Example:
  // Current highest = 20
  // New Create default = 21
  //
  // Still editable from UI.
  // ============================================================

  private getNextDisplayOrder():
    number {

    const maxDisplayOrder =
      this.menus
        .filter(
          (menu) =>
            menu.isDeleted === 0,
        )
        .reduce(
          (
            currentMax,
            menu,
          ) =>
            Math.max(
              currentMax,
              Number(
                menu.displayOrder || 0,
              ),
            ),
          0,
        );


    return (
      maxDisplayOrder + 1
    );
  }


  // ============================================================
  // MODULE CHANGE
  // ============================================================

  onModuleNameChange(
    preserveCurrentModuleId:
      boolean = false,
  ): void {

    const moduleName =
      String(
        this.form.moduleName || "",
      ).trim();


    const selectedId =
      preserveCurrentModuleId
        ? Number(
            this.form.moduleId || 0,
          )
        : 0;


    this.moduleEntities = [];


    if (
      !preserveCurrentModuleId
    ) {

      /*
       * Menu ModuleId is OPTIONAL.
       */
      this.form.moduleId =
        null;
    }


    if (
      !moduleName
    ) {

      this.form.moduleId =
        null;

      return;
    }


    const normalizedModule =
      this.normalizeModuleName(
        moduleName,
      );


    /*
     * Common/Global does not need an institution.
     */
    if (
      normalizedModule ===
        "common"
    ) {

      this.form.moduleId =
        null;

      return;
    }


    this.loadModuleEntities(
      moduleName,
      selectedId,
    );
  }


  // ============================================================
  // LOAD ONBOARDED ENTITY
  // ============================================================

  private loadModuleEntities(
    moduleName: string,
    selectedId:
      number = 0,
  ): void {

    const normalizedModule =
      this.normalizeModuleName(
        moduleName,
      );


    let requestUrl =
      "";


    if (
      normalizedModule ===
        "school"
    ) {

      requestUrl =
        SchoolMaster_ReadAllPaginated;

    } else if (
      normalizedModule ===
        "hospital"
    ) {

      requestUrl =
        HospitalMaster_ReadAllPaginated;

    } else if (
      normalizedModule ===
        "society"
    ) {

      requestUrl =
        Society_ReadAllPaginated;

    } else {

      this.moduleEntities = [];

      this.form.moduleId =
        null;

      return;
    }


    const request = {

      pageSize: 1000,

      pageNo: 1,

      whereClause: null,

      orderByClause: null,

    };


    this.loadingModuleEntities =
      true;


    this.http
      .post<any>(
        requestUrl,
        request,
      )
      .pipe(
        finalize(() => {

          this.loadingModuleEntities =
            false;
        }),
      )
      .subscribe({

        next: (response) => {

          const records =
            this.extractArray(
              response,
            );


          this.moduleEntities =
            records
              .filter(
                (item: any) =>
                  this.isValidOnboardedEntity(
                    item,
                  ),
              )
              .map(
                (item: any) =>
                  this.mapModuleEntity(
                    item,
                    normalizedModule,
                  ),
              )
              .filter(
                (item) =>
                  item.id > 0 &&
                  !!item.name,
              )
              .sort(
                (a, b) =>
                  a.name.localeCompare(
                    b.name,
                  ),
              );


          if (
            selectedId > 0 &&
            this.moduleEntities.some(
              (item) =>
                Number(item.id) ===
                Number(selectedId),
            )
          ) {

            this.form.moduleId =
              selectedId;

          } else if (
            selectedId <= 0
          ) {

            this.form.moduleId =
              null;
          }

        },


        error: (error) => {

          console.error(
            `${moduleName} entity loading error:`,
            error,
          );


          this.moduleEntities = [];


          this.toastr.error(
            `Unable to load onboarded ${this.getModuleEntityPluralLabel(moduleName)}.`,
          );
        },

      });
  }


  // ============================================================
  // ONBOARDED ENTITY FILTER
  // ============================================================

  private isValidOnboardedEntity(
    item: any,
  ): boolean {

    const isActive =
      Number(
        item?.isActive ??
        item?.IsActive ??
        1,
      );


    const isDeleted =
      Number(
        item?.isDeleted ??
        item?.IsDeleted ??
        0,
      );


    if (
      isActive !== 1 ||
      isDeleted !== 0
    ) {

      return false;
    }


    const rawStatus =
      item?.onBoardingStatus ??
      item?.OnBoardingStatus ??
      item?.onboardingStatus ??
      item?.OnboardingStatus;


    if (
      rawStatus === undefined ||
      rawStatus === null ||
      String(rawStatus).trim() ===
        ""
    ) {

      return true;
    }


    const status =
      String(
        rawStatus,
      )
        .trim()
        .toLowerCase();


    return (
      status === "completed" ||
      status === "complete" ||
      status === "onboarded" ||
      status ===
        "onboarding completed"
    );
  }


  // ============================================================
  // COMMON ENTITY MAPPER
  // ============================================================

  private mapModuleEntity(
    item: any,
    normalizedModule: string,
  ): ModuleEntityItem {

    if (
      normalizedModule ===
        "school"
    ) {

      return {

        id:
          Number(
            item?.schoolId ??
            item?.SchoolId ??
            0,
          ),

        name:
          String(
            item?.schoolName ??
            item?.SchoolName ??
            "",
          ).trim(),

      };
    }


    if (
      normalizedModule ===
        "hospital"
    ) {

      return {

        id:
          Number(
            item?.hospitalId ??
            item?.HospitalId ??
            0,
          ),

        name:
          String(
            item?.hospitalName ??
            item?.HospitalName ??
            "",
          ).trim(),

      };
    }


    if (
      normalizedModule ===
        "society"
    ) {

      return {

        id:
          Number(
            item?.societyId ??
            item?.SocietyId ??
            0,
          ),

        name:
          String(
            item?.societyName ??
            item?.SocietyName ??
            "",
          ).trim(),

      };
    }


    return {
      id: 0,
      name: "",
    };
  }


  // ============================================================
  // ENTITY UI HELPERS
  // ============================================================

  get requiresModuleEntity():
    boolean {

    const moduleName =
      this.normalizeModuleName(
        this.form.moduleName,
      );


    return (
      moduleName === "school" ||
      moduleName === "hospital" ||
      moduleName === "society"
    );
  }


  get moduleEntityLabel():
    string {

    const moduleName =
      this.normalizeModuleName(
        this.form.moduleName,
      );


    if (
      moduleName === "school"
    ) {

      return "Onboarded School";
    }


    if (
      moduleName === "hospital"
    ) {

      return "Onboarded Hospital";
    }


    if (
      moduleName === "society"
    ) {

      return "Onboarded Society";
    }


    return "Onboarded Entity";
  }


  get moduleEntityPlaceholder():
    string {

    if (
      !this.form.moduleName
    ) {

      return "Select Module first";
    }


    if (
      !this.requiresModuleEntity
    ) {

      return "All / Not specific";
    }


    return `Select ${this.moduleEntityLabel} or keep All`;
  }


  private getModuleEntityPluralLabel(
    moduleName: string,
  ): string {

    const normalized =
      this.normalizeModuleName(
        moduleName,
      );


    if (
      normalized === "school"
    ) {

      return "schools";
    }


    if (
      normalized === "hospital"
    ) {

      return "hospitals";
    }


    if (
      normalized === "society"
    ) {

      return "societies";
    }


    return "entities";
  }


  // ============================================================
  // PARENT MENUS
  // ============================================================

  get parentMenus():
    MenuItem[] {

    return this.menus
      .filter(
        (menu) =>

          menu.isDeleted === 0

          &&

          menu.isActive === 1

          &&

          Number(
            menu.parentMenuId || 0,
          ) === 0

          &&

          Number(
            menu.menuId,
          ) !==
          Number(
            this.form.menuId,
          ),
      )
      .sort(
        (a, b) =>
          Number(
            a.displayOrder || 0,
          )
          -
          Number(
            b.displayOrder || 0,
          ),
      );
  }


  // ============================================================
  // DEFAULT CHILD
  // ============================================================

  get defaultChildMenus():
    MenuItem[] {

    if (
      this.form.menuId <= 0
    ) {

      return [];
    }


    return this.menus
      .filter(
        (menu) =>

          Number(
            menu.parentMenuId || 0,
          ) ===
          Number(
            this.form.menuId,
          )

          &&

          menu.isDeleted === 0,
      )
      .sort(
        (a, b) =>
          Number(
            a.displayOrder || 0,
          )
          -
          Number(
            b.displayOrder || 0,
          ),
      );
  }


  // ============================================================
  // FILTERED MENUS
  // ============================================================

  get filteredMenus():
    MenuItem[] {

    const search =
      String(
        this.searchText || "",
      )
        .trim()
        .toLowerCase();


    const moduleFilter =
      String(
        this.moduleFilter || "",
      )
        .trim()
        .toLowerCase();


    return this.menus.filter(
      (menu) => {

        const menuName =
          String(
            menu.menuName || "",
          ).toLowerCase();


        const menuCode =
          String(
            menu.menuCode || "",
          ).toLowerCase();


        const templatePath =
          String(
            menu.templatePath || "",
          ).toLowerCase();


        const menuDesc =
          String(
            menu.menuDesc || "",
          ).toLowerCase();


        const moduleName =
          this.normalizeModuleName(
            menu.moduleName,
          );


        const searchMatch =

          !search

          ||

          menuName.includes(
            search,
          )

          ||

          menuCode.includes(
            search,
          )

          ||

          templatePath.includes(
            search,
          )

          ||

          menuDesc.includes(
            search,
          );


        const moduleMatch =

          !moduleFilter

          ||

          moduleName ===
            moduleFilter

          ||

          (
            moduleFilter ===
              "common"

            &&

            (
              !moduleName ||
              moduleName ===
                "global"
            )
          );


        return (
          searchMatch &&
          moduleMatch
        );
      },
    );
  }


  // ============================================================
  // CLIENT SIDE PAGINATION
  // ============================================================

  get paginatedMenus():
    MenuItem[] {

    const start =
      (
        this.pageNo - 1
      )
      *
      this.pageSize;


    return this.filteredMenus.slice(
      start,
      start +
      this.pageSize,
    );
  }


  get totalPages():
    number {

    return Math.max(
      1,
      Math.ceil(
        this.filteredMenus.length /
        this.pageSize,
      ),
    );
  }


  // ============================================================
  // CREATE FORM
  // ============================================================

  openCreate(): void {

    this.resetForm();


    /*
     * AUTO DISPLAY ORDER.
     */
    this.form.displayOrder =
      this.getNextDisplayOrder();


    this.showForm = true;
  }


  // ============================================================
  // EDIT MENU
  // ============================================================

  editMenu(
    menu: MenuItem,
  ): void {

    this.form = {

      menuId:
        Number(
          menu.menuId || 0,
        ),

      menuName:
        String(
          menu.menuName || "",
        ),

      menuCode:
        String(
          menu.menuCode || "",
        ),

      menuDesc:
        String(
          menu.menuDesc || "",
        ),

      displayOrder:
        Number(
          menu.displayOrder || 0,
        ),

      parentMenuId:
        Number(
          menu.parentMenuId || 0,
        ),

      defaultChildMenuId:
        Number(
          menu.defaultChildMenuId || 0,
        ),

      menuIconUrl:
        String(
          menu.menuIconUrl || "",
        ),

      templatePath:
        String(
          menu.templatePath || "",
        ),

      isActive:
        Number(
          menu.isActive ?? 1,
        ),

      moduleName:
        String(
          menu.moduleName || "",
        ),

      moduleId:
        menu.moduleId &&
        Number(menu.moduleId) > 0
          ? Number(
              menu.moduleId,
            )
          : null,

    };


    this.onModuleNameChange(
      true,
    );


    this.showForm = true;


    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }


  // ============================================================
  // CANCEL
  // ============================================================

  cancelForm(): void {

    this.showForm = false;

    this.resetForm();
  }


  // ============================================================
  // AUTO MENU CODE + PATH
  // ============================================================

  menuNameBlur(): void {

    const slug =
      this.slugify(
        this.form.menuName,
      );


    if (
      !this.form.menuCode.trim()
    ) {

      this.form.menuCode =
        slug;
    }


    if (
      !this.form.templatePath.trim()
    ) {

      this.form.templatePath =
        `/${slug}`;
    }
  }


  // ============================================================
  // SAVE MENU
  // ============================================================

  saveMenu(): void {

    if (
      this.saving
    ) {

      return;
    }


    this.menuNameBlur();


    const menuName =
      String(
        this.form.menuName || "",
      ).trim();


    const menuCode =
      String(
        this.form.menuCode || "",
      ).trim();


    if (
      !menuName
    ) {

      this.toastr.warning(
        "Menu Name is required.",
      );

      return;
    }


    if (
      !menuCode
    ) {

      this.toastr.warning(
        "Menu Code is required.",
      );

      return;
    }


    if (
      Number(
        this.form.displayOrder,
      ) <= 0
    ) {

      this.toastr.warning(
        "Display Order must be greater than 0.",
      );

      return;
    }


    if (
      this.form.menuId > 0
    ) {

      this.updateMenu();

      return;
    }


    const duplicate =
      this.menus.some(
        (menu) =>

          menu.isDeleted === 0

          &&

          String(
            menu.menuCode || "",
          )
            .trim()
            .toLowerCase()
          ===
          menuCode.toLowerCase(),
      );


    if (
      duplicate
    ) {

      this.toastr.warning(
        "Menu Code already exists.",
      );

      return;
    }


    const request = {

      menuName:
        menuName,

      menuCode:
        menuCode,

      menuDesc:
        String(
          this.form.menuDesc || "",
        ).trim(),

      displayOrder:
        Number(
          this.form.displayOrder,
        ),

      parentMenuId:
        Number(
          this.form.parentMenuId || 0,
        ),

      defaultChildMenuId:
        Number(
          this.form.defaultChildMenuId || 0,
        ),

      menuIconUrl:
        String(
          this.form.menuIconUrl || "",
        ).trim(),

      templatePath:
        String(
          this.form.templatePath || "",
        ).trim(),

      actionUser:
        this.getActionUser(),

      moduleName:
        String(
          this.form.moduleName || "",
        ).trim(),

      /*
       * OPTIONAL:
       * null is passed when no institution selected.
       */
      moduleId:
        this.normalizeOptionalModuleId(
          this.form.moduleId,
        ),

    };


    console.log(
      "MenuMaster Create Request:",
      request,
    );


    this.saving = true;


    this.http
      .post<any>(
        MenuMaster_create,
        request,
      )
      .pipe(
        finalize(() => {

          this.saving = false;
        }),
      )
      .subscribe({

        next: (response) => {

          console.log(
            "MenuMaster Create Response:",
            response,
          );


          this.toastr.success(
            "Menu created successfully.",
          );


          this.showForm = false;

          this.resetForm();

          this.pageNo = 1;

          this.loadMenus();
        },


        error: (error) => {

          console.error(
            "MenuMaster Create Error:",
            error,
          );


          this.showError(
            error,
            "Unable to create menu.",
          );
        },

      });
  }


  // ============================================================
  // UPDATE MENU
  // ============================================================

  private updateMenu():
    void {

    const request = {

      menuId:
        Number(
          this.form.menuId,
        ),

      menuName:
        String(
          this.form.menuName || "",
        ).trim(),

      menuCode:
        String(
          this.form.menuCode || "",
        ).trim(),

      menuDesc:
        String(
          this.form.menuDesc || "",
        ).trim(),

      displayOrder:
        Number(
          this.form.displayOrder,
        ),

      parentMenuId:
        Number(
          this.form.parentMenuId || 0,
        ),

      defaultChildMenuId:
        Number(
          this.form.defaultChildMenuId || 0,
        ),

      menuIconUrl:
        String(
          this.form.menuIconUrl || "",
        ).trim(),

      templatePath:
        String(
          this.form.templatePath || "",
        ).trim(),

      isActive:
        Number(
          this.form.isActive,
        ),

      actionUser:
        this.getActionUser(),

      moduleName:
        String(
          this.form.moduleName || "",
        ).trim(),

      /*
       * OPTIONAL:
       */
      moduleId:
        this.normalizeOptionalModuleId(
          this.form.moduleId,
        ),

    };


    console.log(
      "MenuMaster Update Request:",
      request,
    );


    this.saving = true;


    this.http
      .post<any>(
        MenuMaster_update,
        request,
      )
      .pipe(
        finalize(() => {

          this.saving = false;
        }),
      )
      .subscribe({

        next: (response) => {

          console.log(
            "MenuMaster Update Response:",
            response,
          );


          this.toastr.success(
            "Menu updated successfully.",
          );


          this.showForm = false;

          this.resetForm();

          this.loadMenus();
        },


        error: (error) => {

          console.error(
            "MenuMaster Update Error:",
            error,
          );


          this.showError(
            error,
            "Unable to update menu.",
          );
        },

      });
  }


  // ============================================================
  // DELETE MENU
  // ============================================================

  deleteMenu(
    menu: MenuItem,
  ): void {

    const children =
      this.menus.filter(
        (item) =>

          Number(
            item.parentMenuId || 0,
          ) ===
          Number(
            menu.menuId,
          )

          &&

          item.isDeleted === 0,
      );


    if (
      children.length > 0
    ) {

      this.toastr.warning(
        "This menu has child menus. Remove or move the child menus first.",
      );

      return;
    }


    const confirmed =
      window.confirm(
        `Delete menu "${menu.menuName}"?`,
      );


    if (
      !confirmed
    ) {

      return;
    }


    const request = {

      menuId:
        Number(
          menu.menuId,
        ),

      actionUser:
        this.getActionUser(),

    };


    this.http
      .post<any>(
        MenuMaster_delete,
        request,
      )
      .subscribe({

        next: () => {

          this.toastr.success(
            "Menu deleted successfully.",
          );


          if (
            Number(
              this.form.menuId,
            )
            ===
            Number(
              menu.menuId,
            )
          ) {

            this.showForm = false;

            this.resetForm();
          }


          this.loadMenus();
        },


        error: (error) => {

          console.error(
            "MenuMaster Delete Error:",
            error,
          );


          this.showError(
            error,
            "Unable to delete menu.",
          );
        },

      });
  }


  // ============================================================
  // PARENT NAME
  // NO RAW ID FALLBACK
  // ============================================================

  getParentName(
    parentMenuId: number,
  ): string {

    const id =
      Number(
        parentMenuId || 0,
      );


    if (
      id <= 0
    ) {

      return "Root";
    }


    const parent =
      this.menus.find(
        (menu) =>
          Number(
            menu.menuId,
          )
          ===
          id,
      );


    return (
      parent?.menuName ||
      "Parent Menu"
    );
  }


  // ============================================================
  // PAGINATION
  // ============================================================

  previousPage(): void {

    if (
      this.pageNo > 1
    ) {

      this.pageNo--;
    }
  }


  nextPage(): void {

    if (
      this.pageNo <
      this.totalPages
    ) {

      this.pageNo++;
    }
  }


  // ============================================================
  // RESET FORM
  // ============================================================

  private resetForm(): void {

    this.form = {

      menuId: 0,

      menuName: "",

      menuCode: "",

      menuDesc: "",

      /*
       * New menu gets next DB/list order.
       */
      displayOrder:
        this.getNextDisplayOrder(),

      parentMenuId: 0,

      defaultChildMenuId: 0,

      menuIconUrl:
        "bi bi-grid",

      templatePath: "",

      isActive: 1,

      moduleName: "",

      /*
       * Optional.
       */
      moduleId: null,

    };


    this.moduleEntities = [];

    this.loadingModuleEntities =
      false;
  }


  // ============================================================
  // OPTIONAL MODULE ID NORMALIZER
  // ============================================================

  private normalizeOptionalModuleId(
    value: number | null,
  ): number | null {

    if (
      value === null ||
      value === undefined
    ) {

      return null;
    }


    const numericValue =
      Number(
        value,
      );


    if (
      Number.isNaN(
        numericValue,
      )
      ||
      numericValue <= 0
    ) {

      return null;
    }


    return numericValue;
  }


  // ============================================================
  // MODULE NAME NORMALIZER
  // ============================================================

  private normalizeModuleName(
    value: string,
  ): string {

    const moduleName =
      String(
        value || "",
      )
        .trim()
        .toLowerCase();


    if (
      moduleName ===
        "housing society"
    ) {

      return "society";
    }


    if (
      moduleName ===
        "global"
    ) {

      return "common";
    }


    return moduleName;
  }


  // ============================================================
  // SLUG
  // ============================================================

  private slugify(
    value: string,
  ): string {

    return String(
      value || "",
    )
      .trim()
      .toLowerCase()
      .replace(
        /[^a-z0-9]+/g,
        "-",
      )
      .replace(
        /^-+|-+$/g,
        "",
      );
  }


  // ============================================================
  // PAGE SAFETY
  // ============================================================

  private ensurePage(): void {

    if (
      this.pageNo >
      this.totalPages
    ) {

      this.pageNo =
        this.totalPages;
    }


    if (
      this.pageNo < 1
    ) {

      this.pageNo = 1;
    }
  }


  // ============================================================
  // EXTRACT RESPONSE ARRAY
  // ============================================================

  private extractArray(
    response: any,
  ): any[] {

    if (
      !response
    ) {

      return [];
    }


    if (
      Array.isArray(
        response,
      )
    ) {

      return response;
    }


    const candidates = [

      response?.items,
      response?.Items,

      response?.data,
      response?.Data,

      response?.data?.items,
      response?.data?.Items,

      response?.Data?.items,
      response?.Data?.Items,

      response?.result,
      response?.Result,

      response?.result?.items,
      response?.result?.Items,

      response?.Result?.items,
      response?.Result?.Items,

      response?.responseData,
      response?.ResponseData,

      response?.responseData?.items,
      response?.responseData?.Items,

      response?.ResponseData?.items,
      response?.ResponseData?.Items,

      response?.list,
      response?.List,

      response?.value,
      response?.Value,

    ];


    for (
      const candidate
      of candidates
    ) {

      if (
        Array.isArray(
          candidate,
        )
      ) {

        return candidate;
      }
    }


    const deepCandidates = [

      response?.items?.data,

      response?.items?.items,

      response?.data?.data,

      response?.result?.data,

      response?.responseData?.data,

    ];


    for (
      const candidate
      of deepCandidates
    ) {

      if (
        Array.isArray(
          candidate,
        )
      ) {

        return candidate;
      }
    }


    return [];
  }


  // ============================================================
  // NORMALIZE MENU
  // ============================================================

  private normalizeMenu(
    item: any,
  ): MenuItem {

    const rawModuleId =
      item?.moduleId ??
      item?.ModuleId ??
      null;


    const numericModuleId =
      rawModuleId === null ||
      rawModuleId === undefined
        ? null
        : Number(
            rawModuleId,
          );


    return {

      menuId:
        Number(
          item?.menuId ??
          item?.MenuId ??
          0,
        ),

      menuName:
        String(
          item?.menuName ??
          item?.MenuName ??
          "",
        ),

      menuCode:
        String(
          item?.menuCode ??
          item?.MenuCode ??
          "",
        ),

      menuDesc:
        String(
          item?.menuDesc ??
          item?.MenuDesc ??
          "",
        ),

      displayOrder:
        Number(
          item?.displayOrder ??
          item?.DisplayOrder ??
          0,
        ),

      parentMenuId:
        Number(
          item?.parentMenuId ??
          item?.ParentMenuId ??
          0,
        ),

      defaultChildMenuId:
        Number(
          item?.defaultChildMenuId ??
          item?.DefaultChildMenuId ??
          0,
        ),

      menuIconUrl:
        String(
          item?.menuIconUrl ??
          item?.MenuIconUrl ??
          "",
        ),

      templatePath:
        String(
          item?.templatePath ??
          item?.TemplatePath ??
          "",
        ),

      isActive:
        Number(
          item?.isActive ??
          item?.IsActive ??
          1,
        ),

      isDeleted:
        Number(
          item?.isDeleted ??
          item?.IsDeleted ??
          0,
        ),

      moduleName:
        String(
          item?.moduleName ??
          item?.ModuleName ??
          "",
        ),

      moduleId:
        numericModuleId &&
        numericModuleId > 0
          ? numericModuleId
          : null,

    };
  }


  // ============================================================
  // ACTION USER
  // ============================================================

  private getActionUser():
    string {

    const actionUser =
      (
        localStorage.getItem(
          "userId",
        )

        ||

        localStorage.getItem(
          "UserId",
        )

        ||

        "SYSTEM"
      )
        .replace(
          /^"|"$/g,
          "",
        )
        .trim();


    return (
      actionUser ||
      "SYSTEM"
    );
  }


  // ============================================================
  // ERROR
  // ============================================================

  private showError(
    error: any,
    fallback: string,
  ): void {

    let message =

      error?.error?.message

      ??

      error?.error?.Message

      ??

      error?.error?.title

      ??

      error?.error?.Title

      ??

      error?.message

      ??

      fallback;


    if (
      typeof error?.error ===
        "string"

      &&

      error.error.trim()
    ) {

      message =
        error.error.trim();
    }


    this.toastr.error(
      String(
        message ||
        fallback,
      ),
    );
  }
}